'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chip = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Chip = require('@material-ui/core/Chip');

var _Chip2 = _interopRequireDefault(_Chip);

var _styles = require('@material-ui/core/styles');

var _Avatar = require('@material-ui/core/Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Typography = require('../Typography');

var _chip = require('../../schema/component/chip.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


// Lazy Load
var CancelIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/Cancel');
});
var CheckIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/Check');
});
var ImageIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/Image');
});

// All Properties
var defaultProperties = _chip.properties.default.properties.default.properties;
var selectedProperties = _chip.properties.default.properties.selected.properties;
var disabledProperties = _chip.properties.default.properties.disabled.properties;
var variantProperties = _chip.properties.variant.properties;
var typeProperties = _chip.properties.type.properties;

var useStyles = (0, _styles.makeStyles)({
  container: {
    borderRadius: function borderRadius(_ref) {
      var containerIsRounded = _ref.containerIsRounded;
      return containerIsRounded ? '20px' : '4px';
    },
    background: function background(_ref2) {
      var containerBackground = _ref2.containerBackground;
      return containerBackground;
    },
    border: function border(_ref3) {
      var containerBorder = _ref3.containerBorder;
      return containerBorder;
    },
    minWidth: function minWidth(_ref4) {
      var containerIsCustomLabel = _ref4.containerIsCustomLabel;
      return containerIsCustomLabel ? '100px' : '0px';
    },
    '&:hover': {
      background: function background(_ref5) {
        var containerBackground = _ref5.containerBackground;
        return containerBackground;
      }
    },
    '& .MuiAvatar-root': {
      borderRadius: '0px'
    },
    '& .MuiAvatar-colorDefault': {
      background: 'none',
      color: 'var(--onsurface-disable)'
    },
    '& .MuiChip-avatar': {
      height: '20px',
      width: '20px'
    },
    '& .MuiChip-avatar .MuiAvatar-fallback': {
      height: '14px',
      width: '14px'
    },
    '& .MuiChip-label': {
      padding: '0px',
      marginLeft: 'calc(6px + 8px)',
      marginRight: '12px'
    },
    '& .icon-prefix': {
      color: function color(_ref6) {
        var containerIconColor = _ref6.containerIconColor;
        return containerIconColor;
      },
      fontSize: '20px',
      marginLeft: '6px',
      marginRight: 'calc(-16px + 6px)'
    },
    '& .icon-suffix': {
      color: function color(_ref7) {
        var containerIconColor = _ref7.containerIconColor;
        return containerIconColor;
      },
      fontSize: '16px',
      marginRight: '8px'
    },
    '&.Mui-disabled': {
      opacity: 1
    },
    '& .avatar-right': {
      height: '20px',
      marginRight: '4px',
      width: '20px'
    },
    '& .avatar-right > svg': {
      fontSize: '20px'
    }
  },
  label: {
    color: function color(_ref8) {
      var labelColor = _ref8.labelColor;
      return labelColor;
    }
  }
});

var Chip = function Chip(_ref9) {
  var avatar = _ref9.avatar,
      className = _ref9.className,
      clickable = _ref9.clickable,
      customLabel = _ref9.customLabel,
      deleteIcon = _ref9.deleteIcon,
      disabled = _ref9.disabled,
      Icon = _ref9.Icon,
      isRounded = _ref9.isRounded,
      label = _ref9.label,
      labelVariant = _ref9.labelVariant,
      onDelete = _ref9.onDelete,
      selected = _ref9.selected,
      type = _ref9.type,
      variant = _ref9.variant,
      props = _objectWithoutProperties(_ref9, ['avatar', 'className', 'clickable', 'customLabel', 'deleteIcon', 'disabled', 'Icon', 'isRounded', 'label', 'labelVariant', 'onDelete', 'selected', 'type', 'variant']);

  var variantProps = variantProperties[variant] && variantProperties[variant].properties;
  var variantDefault = variantProperties.outlined.properties;
  var variantSelected = variantProps || variantDefault;

  var typeProps = typeProperties[type] && typeProperties[type].properties;
  var typeDefault = typeProperties.choice.properties;
  var typeSelected = typeProps || typeDefault;

  var onStyleContainerBackground = function onStyleContainerBackground() {
    if (selected && !disabled) return selectedProperties.background;
    if (disabled) return disabledProperties.background;
    return defaultProperties.background;
  };

  var onStyleContainerBorder = function onStyleContainerBorder() {
    if (selected && variant.includes('outlined')) return selectedProperties.borderColor;
    return variantSelected.border;
  };

  var onStyleContainerIconColor = function onStyleContainerIconColor() {
    if (selected && !disabled) return selectedProperties.icon;
    if (disabled) return disabledProperties.icon;
    return defaultProperties.icon;
  };

  var onStyleLabelColor = function onStyleLabelColor() {
    if (selected && !disabled) return selectedProperties.label;
    if (disabled) return disabledProperties.label;
    return defaultProperties.label;
  };

  var onCheckPrefixIcon = function onCheckPrefixIcon() {
    var isIconSelected = typeSelected.iconCondition === 'selected';

    if (typeSelected.icon && isIconSelected && selected) return true;
    if (typeSelected.icon && !typeSelected.iconCondition) return true;

    return false;
  };

  var onCheckDeleteIcon = function onCheckDeleteIcon() {
    if (typeSelected.isCloseIcon) return onDelete;
    if (typeSelected.isAvatarRight) return function () {};

    return null;
  };

  var ChipIconPrefix = function ChipIconPrefix() {
    if (Icon) return _react2.default.createElement(Icon, { className: 'icon-prefix' });

    return _react2.default.createElement(
      _react.Suspense,
      { fallback: _react2.default.createElement('div', null) },
      _react2.default.createElement(CheckIcon, { className: 'icon-prefix' })
    );
  };

  var ChipIconSuffix = function ChipIconSuffix() {
    return _react2.default.createElement(
      _react.Suspense,
      { fallback: _react2.default.createElement('div', null) },
      _react2.default.createElement(CancelIcon, { className: 'icon-suffix' })
    );
  };

  var ChipIconDelete = function ChipIconDelete() {
    if (typeSelected.isCloseIcon) {
      return _react2.default.createElement(ChipIconSuffix, null);
    }

    if (typeSelected.isAvatarRight) {
      return _react2.default.createElement(
        _Avatar2.default,
        { className: 'avatar-right', src: avatar },
        _react2.default.createElement(
          _react.Suspense,
          { fallback: _react2.default.createElement('div', null) },
          _react2.default.createElement(ImageIcon, null)
        )
      );
    }

    return null;
  };

  var classess = useStyles({
    containerBackground: onStyleContainerBackground(),
    containerBorder: onStyleContainerBorder(),
    containerIconColor: onStyleContainerIconColor(),
    containerIsCustomLabel: variantSelected.isCustomLabel,
    containerIsRounded: isRounded,
    labelColor: onStyleLabelColor()
  });

  return _react2.default.createElement(_Chip2.default, _extends({}, props, {
    disabled: disabled,
    avatar: typeSelected.isAvatarLeft ? _react2.default.createElement(
      _Avatar2.default,
      { src: avatar },
      _react2.default.createElement(
        _react.Suspense,
        { fallback: _react2.default.createElement('div', null) },
        _react2.default.createElement(ImageIcon, null)
      )
    ) : null,
    deleteIcon: deleteIcon || _react2.default.createElement(ChipIconDelete, null),
    icon: onCheckPrefixIcon() ? _react2.default.createElement(ChipIconPrefix, null) : null,
    onDelete: onCheckDeleteIcon(),
    clickable: clickable,
    className: 'chip ' + classess.container + ' ' + className,
    label: customLabel || _react2.default.createElement(
      _Typography.Typography,
      { variant: labelVariant, className: 'chip-label ' + classess.label },
      label
    )
  }));
};

exports.Chip = Chip;
Chip.defaultProps = {
  avatar: '',
  className: '',
  clickable: true,
  customLabel: null,
  deleteIcon: null,
  disabled: false,
  Icon: null,
  isRounded: false,
  label: '',
  labelVariant: 'textbody3-reguler',
  onDelete: function onDelete() {},
  selected: false,
  type: 'choice',
  variant: 'outlined'
};

Chip.propTypes = {
  avatar: _propTypes2.default.string,
  className: _propTypes2.default.string,
  clickable: _propTypes2.default.bool,
  customLabel: _propTypes2.default.node,
  deleteIcon: _propTypes2.default.node,
  disabled: _propTypes2.default.bool,
  Icon: _propTypes2.default.node,
  isRounded: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  labelVariant: _propTypes2.default.string,
  onDelete: _propTypes2.default.func,
  selected: _propTypes2.default.bool,
  type: _propTypes2.default.string,
  variant: _propTypes2.default.string
};

exports.default = Chip;